<template>
  <div class="complete">
    <div class="complete-header">
      <ff-button :action="logout" :text="'Logout'" :options="{ backgroundColor: '#272727'}"/>
    </div>
    <div class="complete-container">
      <h1>Creation Complete!</h1>
      <h2 v-if="subdomain">Congratulations, you've created your own platform! You've also reserved the name <span class="subdomain">{{subdomain}}</span>.</h2>
      <h2 v-if="!subdomain">Congratulations, you've created your own platform!</h2>
      <p>We need to do some work behind the scenes to set this up. We'll email you as soon as we're ready. In the meantime, feel free to ask us any questions <a href="mailto:admin@fanfolk.com">here</a>.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { auth } from '../../helpers/firebase'
import FFButton from '../DesignSystem/FFButton'
import analytics from '../../mixins/analytics'

export default {
  name: 'CreationComplete',
  props: {
  },
  mixins: [
    analytics
  ],
  components: {
    'ff-button': FFButton
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['user']),
    body () {
      if (this.$route.query.subdomain) {
        return `Congratulations, you've created a platform with the ${this.$route.query.subdomain} domain!`
      }
      return `Congratulations, you've created a platform!`
    },
    subdomain () {
      return this.$route.query.subdomain
    }
  },
  mounted () {
    this.$confetti.start()
    setTimeout(() => {
      this.$confetti.stop()
    }, 3000)
    this.trackAndIdentify('[Fanfolk] Channel Created')
  },
  methods: {
    logout () {
      auth.signOut().then(() => {
        return this.$router.push({name: 'signup'})
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .complete {
    height: 100%;
    background: $color-dark;
    overflow: auto;
  }

  .complete-container {
    @include container;
  }

  h1 {
    @include h1;
    color: $color-white;
  }

  h2 {
    line-height: $lineHeight;
    opacity: 1;
    font-size: $fontSize-medium;
    color: $color-white;
    margin-bottom: $unit-3;
  }

  p {
    @extend h2;
    color: $color-white;
  }

  .subdomain {
    font-size: $fontSize-medium;
    padding: .15em .25em .25em;
    margin: 0 .25em;
    border-radius: $borderRadius;
    background: $color-main;
    color: $color-white;
    // background: rgba($color-white, 0.1);
  }

  .complete-header {
    padding: 1rem;
  }

  @import "../../assets/styles/mobile.scss";

</style>
